(function () {
  'use strict';

  angular.module('wsLrs.directives').directive('typeaheadTriggerOpen', function ($parse, $timeout) {
    return {
      restrict: 'A',
      require: 'ngModel',
      scope: {
        typeaheadTriggerOpen: "=?"
      },
      link: function link($scope, elem) {
        $scope.typeaheadTriggerOpen = function () {
          var ctrl = elem.controller('ngModel'),
            prev = ctrl.$modelValue || '';
          if (prev) {
            ctrl.$setViewValue('');
            $timeout(function () {
              ctrl.$setViewValue(prev);
            });
          } else {
            ctrl.$setViewValue(' ');
          }
        };
      }
    };
  });
})();
